module.exports = __webpack_public_path__ + "media/src/img/payment/qr_mbank_tenge_som_qr_modal-73cc264293bba4be988e73cc4a7e0432.png";